export const categories = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Discover sneakers, casual shoes, boots and more',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20pair%20of%20minimalist%20white%20leather%20sneakers%20on%20warm%20beige%20surface%2C%20soft%20natural%20side%20lighting%2C%20clean%20editorial%20product%20photography%2C%20simple%20sophisticated%20composition%2C%20neutral%20cream%20background%2C%20high%20fashion%20catalog%20aesthetic%2C%20subtle%20shadows%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-shoes-img-001&orientation=landscape',
  },
  {
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Cozy hoodies, pullovers, and sweaters for every season',
    image: 'https://readdy.ai/api/search-image?query=Premium%20heavyweight%20cotton%20hoodie%20in%20warm%20oatmeal%20beige%20color%20folded%20neatly%20on%20light%20cream%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20minimalist%20editorial%20fashion%20photography%2C%20clean%20elegant%20composition%2C%20cozy%20sophisticated%20aesthetic%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-hoodies-img-002&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Graphic tees, basic tees, and designer t-shirts',
    image: 'https://readdy.ai/api/search-image?query=Clean%20white%20cotton%20t-shirt%20neatly%20folded%20on%20warm%20sandy%20beige%20surface%20with%20subtle%20texture%2C%20soft%20natural%20window%20light%2C%20minimalist%20editorial%20product%20photography%2C%20simple%20elegant%20composition%2C%20fresh%20modern%20aesthetic%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-tshirts-img-003&orientation=landscape',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-cloud-windy-line',
    description: 'Bombers, denim jackets, puffer coats and outerwear',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20laid%20flat%20on%20warm%20cream%20textured%20surface%2C%20soft%20natural%20daylight%20from%20above%2C%20editorial%20fashion%20catalog%20photography%2C%20clean%20minimalist%20composition%2C%20sophisticated%20outerwear%20aesthetic%2C%20subtle%20fabric%20texture%20visible%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-jackets-img-004&orientation=landscape',
  },
  {
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Jeans, cargo pants, sweatpants and summer shorts',
    image: 'https://readdy.ai/api/search-image?query=Well%20tailored%20neutral%20beige%20chino%20trousers%20neatly%20folded%20on%20light%20warm%20sand%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20fashion%20product%20photography%2C%20minimalist%20sophisticated%20composition%2C%20elegant%20casual%20aesthetic%2C%20subtle%20fabric%20texture%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-pants-img-005&orientation=landscape',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-smile-line',
    description: 'Caps, beanies, bucket hats and stylish headwear',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20baseball%20cap%20in%20warm%20cream%20tone%20on%20clean%20beige%20surface%2C%20soft%20side%20lighting%20with%20gentle%20shadows%2C%20editorial%20product%20photography%2C%20simple%20sophisticated%20composition%2C%20modern%20lifestyle%20aesthetic%2C%20subtle%20fabric%20texture%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-headwear-img-006&orientation=landscape',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Matching sets, tracksuits and coordinated outfits',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20two%20piece%20lounge%20set%20in%20soft%20sage%20green%20color%20folded%20together%20on%20warm%20cream%20surface%2C%20natural%20diffused%20daylight%2C%20minimalist%20editorial%20fashion%20photography%2C%20clean%20harmonious%20composition%2C%20relaxed%20sophisticated%20aesthetic%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-sets-img-007&orientation=landscape',
  },
  {
    name: 'Underwear / Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-contrast-drop-2-line',
    description: 'Comfortable underwear, boxers, and essentials',
    image: 'https://readdy.ai/api/search-image?query=Premium%20soft%20cotton%20undergarments%20neatly%20arranged%20on%20warm%20beige%20linen%20surface%2C%20soft%20natural%20morning%20light%2C%20clean%20minimalist%20editorial%20product%20photography%2C%20simple%20elegant%20composition%2C%20fresh%20and%20comfortable%20aesthetic%2C%20subtle%20fabric%20texture%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-underwear-img-008&orientation=landscape',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-basketball-line',
    description: 'Sports jerseys, football kits and athletic wear',
    image: 'https://readdy.ai/api/search-image?query=Clean%20athletic%20sports%20jersey%20in%20deep%20forest%20green%20laid%20flat%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%20from%20above%2C%20editorial%20sportswear%20product%20photography%2C%20minimalist%20sophisticated%20composition%2C%20modern%20athletic%20aesthetic%2C%20subtle%20mesh%20fabric%20texture%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-jersey-img-009&orientation=landscape',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Sunglasses, watches, jewelry and fashion accessories',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20wayfarer%20style%20sunglasses%20with%20warm%20tortoise%20frame%20on%20soft%20beige%20surface%20reflecting%20gentle%20light%2C%20refined%20editorial%20product%20photography%2C%20clean%20minimalist%20composition%2C%20sophisticated%20luxury%20accessory%20aesthetic%2C%20subtle%20golden%20reflections%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-accessories-img-010&orientation=landscape',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    description: 'Backpacks, messenger bags, totes and travel bags',
    image: 'https://readdy.ai/api/search-image?query=Premium%20minimalist%20leather%20backpack%20in%20warm%20cognac%20brown%20on%20clean%20cream%20surface%2C%20soft%20natural%20side%20lighting%2C%20sophisticated%20editorial%20product%20photography%2C%20elegant%20clean%20composition%2C%20luxury%20accessory%20aesthetic%2C%20subtle%20leather%20texture%20visible%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-bags-img-011&orientation=landscape',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Leather belts, designer belts and casual belts',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20genuine%20leather%20belt%20with%20subtle%20brass%20buckle%20coiled%20gracefully%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20refined%20editorial%20product%20photography%2C%20minimalist%20sophisticated%20composition%2C%20luxury%20accessory%20aesthetic%2C%20fine%20leather%20texture%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-belts-img-012&orientation=landscape',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Designer fragrances, colognes and luxury perfumes',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20soft%20cream%20surface%2C%20gentle%20diffused%20natural%20lighting%2C%20sophisticated%20editorial%20product%20photography%2C%20clean%20refined%20composition%2C%20luxury%20fragrance%20aesthetic%2C%20subtle%20golden%20highlights%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-perfumes-img-013&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Electronics, home goods and miscellaneous finds',
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20stylish%20lifestyle%20accessories%20including%20portable%20speaker%20notepad%20and%20pen%20arranged%20on%20warm%20beige%20surface%2C%20soft%20natural%20daylight%2C%20clean%20editorial%20product%20photography%2C%20minimalist%20sophisticated%20composition%2C%20modern%20lifestyle%20aesthetic%2C%20no%20text%20no%20people&width=400&height=300&seq=cat-other-img-014&orientation=landscape',
  },
];

export const faqItems = [
  {
    question: 'What is a Pandabuy Spreadsheet?',
    answer: 'A Pandabuy Spreadsheet is a curated collection of verified shopping links, product references, and community-discovered finds organized in an easy-to-browse format. It helps shoppers quickly discover popular fashion items, compare prices, and access reliable product links without spending hours searching through forums and social media.',
  },
  {
    question: 'How does the Pandabuy Spreadsheet work?',
    answer: 'Each spreadsheet category contains organized links to specific products across different platforms. Simply browse the category you are interested in, click through to view the products, and use the links to make your purchases. Our spreadsheets are updated regularly to ensure links stay active and products remain available.',
  },
  {
    question: 'Is the Pandabuy Spreadsheet free to use?',
    answer: 'Yes, browsing our Pandabuy Spreadsheet directory is completely free. We provide organized access to product categories and shopping links at no cost. Simply choose a category and start exploring thousands of verified finds.',
  },
  {
    question: 'How often is the spreadsheet updated?',
    answer: 'Our Pandabuy Spreadsheet is updated daily to ensure all links are working, new products are added, and outdated items are removed. Our community of contributors helps maintain link quality and discover fresh finds across all categories.',
  },
  {
    question: 'Are the product links verified and safe?',
    answer: 'All links in our Pandabuy Spreadsheet go through a verification process. While we strive to keep everything current and safe, we always recommend users exercise standard online shopping precautions and check seller ratings before making purchases.',
  },
  {
    question: 'Which categories are most popular?',
    answer: 'Shoes, Hoodies/Sweaters, and T-Shirts consistently rank as our most popular Pandabuy Spreadsheet categories. These categories feature the largest selection of verified links and receive the most frequent updates with new finds.',
  },
];

export const trustStats = [
  { value: '50,000+', label: 'Verified Links' },
  { value: '14', label: 'Categories' },
  { value: '100+', label: 'Brands Covered' },
  { value: 'Daily', label: 'Updates' },
];

export const comparisonData = [
  { type: 'Shoes', products: '5,000+', difficulty: 'Easy', popularity: 'Very High' },
  { type: 'Hoodies / Sweaters', products: '3,500+', difficulty: 'Easy', popularity: 'High' },
  { type: 'T-Shirts', products: '4,200+', difficulty: 'Easy', popularity: 'Very High' },
  { type: 'Jackets', products: '2,800+', difficulty: 'Easy', popularity: 'High' },
  { type: 'Bags', products: '1,500+', difficulty: 'Medium', popularity: 'Medium' },
  { type: 'Accessories', products: '3,000+', difficulty: 'Easy', popularity: 'High' },
  { type: 'Jersey', products: '1,200+', difficulty: 'Medium', popularity: 'Medium' },
  { type: 'Perfumes', products: '800+', difficulty: 'Medium', popularity: 'Medium' },
];